import { render, staticRenderFns } from "./ImprimirPedidoOs.vue?vue&type=template&id=a4681cc2&scoped=true&"
import script from "./ImprimirPedidoOs.vue?vue&type=script&lang=js&"
export * from "./ImprimirPedidoOs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4681cc2",
  null
  
)

export default component.exports